import { Link } from "react-router";
import { Card } from "../../AbstractElements";
import { Stack } from "react-bootstrap";
import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowLeft01Icon } from "@hugeicons/core-free-icons";
import { useCustomContext } from "../../_helper/customizer";
import { useTranslation } from "react-i18next";

export const PlatFormCard = (props) => {
  const { icon, title, description, link } = props;
  const { layout } = useCustomContext();
  const { t } = useTranslation();
  const isRTL = layout === "rtl";

  return (
    <Link to={link} className="--group">
      <Card style={{ minHeight: "228px" }} className="--slide-up">
        <Stack gap={2}>
          <div className="rounded">
            <div className="icon-container-kaaba border border-1 --rotate">
              {icon}
            </div>
          </div>

          <div>
            <h3>{title}</h3>
            <div className="mt-2">{description}</div>
          </div>
          <div>
            <Link to={link}>
              <Stack direction="horizontal">
                {!isRTL && <HugeiconsIcon icon={ArrowLeft01Icon} />}
                <span className="fw-bold">{t("GO_TO_PLATFORM")}</span>{" "}
                {isRTL && <HugeiconsIcon icon={ArrowLeft01Icon} />}
              </Stack>
            </Link>
          </div>
        </Stack>
      </Card>
    </Link>
  );
};
